export const DEVICES_ADD_ITEM_NAME = 'devicesAddItemName';
export const MANUFACTURER_AS_OWNER_ERROR_CODE = 105000008;
export const ITEMS_TO_DELETE_KEY = 'itemsToDeleteKey';
export const ITEM_ATTRIBUTES = {
  network: ['id', 'name'],
  device: [
    'id',
    'name',
    'manufacturer',
    'product',
    'version',
    'serial',
    'protocol',
    'communication',
    'included',
  ],
  value: ['id', 'name', 'type', 'period', 'delta', 'permission'],
};

export const METHODS = {
  get: 'GET',
  put: 'PUT',
  patch: 'PATCH',
  post: 'POST',
  delete: 'DELETE',
};

export const PERMISSIONS = ['create', 'retrieve', 'update', 'delete'];

export const OVERVIEW_SELECTED_NETWORK_GROUP = 'overviewSelectedNetworkGroup';

export const DASHBOARD_GLOBAL_FILTER_OBJ = 'dashboardGlobalFilterObj_';
export const DASHBOARD_SELECTED_NETWORK = 'dashboardSelectedNetwork_';
export const DASHBOARD_NETWORK_STATUS = 'dashboardNetworkStatus_';

export const DATA_OBJECT_NAME = 'dashboard_wapp_data';
export const DASHBOARD_FETCH_REQUEST = 'data_object_fetched';
export const DASHBOARD_FETCH_OBJ = {
  method: METHODS.get,
  url: '/data',
  query: {
    this_name: DATA_OBJECT_NAME,
    expand: 0,
    order_by: 'this_index',
  },
};

// ------------------------ export csv options ---------------------------------
export const DEFAULT_EXPORT_FILE_TYPE = 'xlsx';
export const DEFAULT_CSV_SETTINGS = {
  separator: ';',
  decimalSeparator: ',',
  custom_separator: '',
};

export const SUPPORTED_SEPARATORS = {
  semicolon: ';',
  comma: ',',
  space: ' ',
  tab: '\t',
  custom: '',
};

export const SUPPORTED_COLUMNSEPARATORS = {
  dot: '.',
  comma: ',',
};
// -----------------------------------------------------------------------------

export const UDM = {
  network: 'network',
  device: 'device',
  value: 'value',
  state: 'state',
} as const;
export const UDM_CHILDREN = { network: 'device', device: 'value', value: 'state' } as const;

export const UDM_KEYS = {
  network: ['name', 'meta.id', 'meta.connection'],
  device: ['meta.name_by_user', 'product', 'version', 'meta.connection'],
  value: ['name', 'meta.id'],
  state: ['type', 'data', 'timestamp'],
};

export const UDM_QUERY = {
  network: { verbose: true },
  device: { verbose: true },
  value: { limit: 20, expand: 1, verbose: true }, // value search, 20 per page
  // expanding device, we fetch all at once, 33 per chuck
  deviceValue: { limit: 33, expand: 1, verbose: true },
};

export const UDM_STATE_VALUES = {
  control: 'Control',
  report: 'Report',
};

export const INSTALLATION_SETTING_VISIBLE = 'installationSettingVisible_';
export const INSTALLATION_UPDATE_ALL = 'installationUpdateAll';

export const SUBSCRIPTIONS_YEARLY_STATE = 'subscriptionsYearlyState';
export const SUBSCRIPTIONS_COMPANY_PRICES = 'subscriptionsCompanyPrices';
export const NEW_SUBSCRIPTION_ID_KEY = 'newSubscriptionIdKey';
export const NEW_PRICE_ID_KEY = 'newPriceIdKey';

export const WAPPSTO_SUPPORT_MAIL = 'support@wappsto.com';
export const SELUXIT_PHONE = '+45 7214 6660';
export const SELUXIT_PHONE_TEL = 'tel:004572146660';

export const APPLICATION_ID = 'APPLICATION_NAME_IDENTIFIER';
export const APPLICATION_PRODUCT_ID = 'APPLICATION_PRODUCT_ID';

// The trigger mode which executes the dropdown action. Array<click|hover|contextMenu>
export const DROPDOWN_TRIGGER: ('click' | 'contextMenu' | 'hover')[] = ['click'];
export const COMPONENT_SIZE = {
  S: 'small' as const,
  M: 'medium' as const, // TODO: This mainly only used with SizeType, but it doesn't fit. SizeType's medium is called middle.
  L: 'large' as const,
} as const;
